module.exports = __webpack_public_path__ + "img/stretching_1_splash.b35b3dfc.jpg";